<div v-if="shouldRenderConfig && getShowAddToCart" v-bind:class="getClassName">
    <button v-if="getIsMobile && !getIsSummaryFooterExpanded" type="button" class="btn btn-primary" 
        ref="addToCartBtn"
        :disabled="getIsAnyPreflightCheckLoading"
        v-bind:class="getDisableClass"
        v-on:click="onClickAddToCartWithSweetAlert">
        <img :class="getClassName + 'Icon'" :src="this.getBaseUrl + '/images/matrix/cart.png'"/>
    </button>    
    <button v-else type="button" class="btn btn-primary" 
        ref="addToCartBtn"
        :disabled="getIsAnyPreflightCheckLoading"
        v-bind:class="getDisableClass"
        v-on:click="onClickAddToCartWithSweetAlert">
        <img :class="getClassName + 'Icon'" :src="this.getBaseUrl + '/images/matrix/cart.png'"/>
        <span>{{ $t('Add to Basket') }}</span>
    </button>
</div>

